let _instances = new WeakMap<Element, Dropdown>();

class Dropdown {
    el:   Element;
    btn:  Element;
    menu: Element;
  
    constructor(el: Element) {
      this.el = el;
  
      this.btn  = el.querySelector(".dropdown-button");
      this.menu = el.querySelector(".dropdown-menu");

      if (!this.btn) {
          return;
      }
  
      this.init();

      _instances.set(el, this);
    }
  
    init() {
      this.btn.addEventListener('click', (e) => {
        this.menu.classList.toggle("open");
      })
    }

    open() {
        this.menu.classList.add("open");
    }

    close() {
        this.menu.classList.remove("open");
    }

    static instance(el: Element): Dropdown|null {
        return _instances.get(el);
    }
  }

  
  // Close dropdowns
  window.addEventListener('click', (e) => {
    const el = (e.target as Element);
    let thisDropDown: Element|null = null;
  
    if (el.matches(".dropdown-button") || el.matches(".dropdown-button *")) {
      thisDropDown = el.closest(".dropdown").querySelector(".dropdown-menu");
    } else if (el.matches(".dropdown-menu")) {
      thisDropDown = el;
    } else if (el.matches(".dropdown-menu *")) {
      thisDropDown = el.closest(".dropdown-menu");
    }
  
    // Close all other dropdowns
    const menus = document.querySelectorAll(".dropdown > .dropdown-menu.open");
  
    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
  
      if (menu !== thisDropDown) {
        menu.classList.remove("open");
      }
    }
  })
  
  export { Dropdown };
  
